<template>
    <div class="bg-white py-3 px-6 shadow-md text-right rounded-md h-full">
        <div v-if="loading" class="flex justify-center items-center w-40 h-28">
            <div>
                <i class="fas fa-spinner animate-spin text-2xl" />
            </div>
        </div>
        <div v-else class="flex justify-between flex-col h-full">
            <div class="pt-2 flex flex-row justify-between items-center">
                <div class="flex flex-row justify-start items-center w-2/3">

                    <icons
                        :icon="icons[crypto.key].icon"
                        :color="icons[crypto.key].color"
                        size="3"
                    />
                    <div class="text-sm text-gray-500 pl-2">
                        {{ crypto.key }}
                    </div>
                </div>
            </div>
            <div class=" text-left pt-2">
                <div class="text-base font-bold">
                    {{ `${numberFormat(crypto.crypto_amount, crypto.key)} ${crypto.key}` }}
                </div>
                <div class="text-xxs text-gray-500">
                    Atualizado em {{ requestDate }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import numberFormat from "../utils/numberFormat";
import icons from "../utils/icons";
import Icons from './Icons'

export default {
    components: {
        Icons
    },
    props: {
        crypto: { type: Object, required: true },
        balance: { type: Object, required: true },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            numberFormat,
            icons
        };
    },
    computed: {
        requestDate(){
            return this.balance.request_date
                ? this.$options.filters.smallDateTime(this.balance.request_date)
                : '--/--/----'
        }
    },
    methods: {},
};
</script>
